import {ServiceCharge} from '../../model/admin/servicecharge';
import {BaseResponse} from '../internal/baseresponse';
export class ADMServiceChargeResult extends BaseResponse {
  data: Array<ServiceCharge>;
}

export class ADMServiceChargeByTypeResult extends BaseResponse {
  data: Array<ADMServiceChargeByType>;
}

export class ADMServiceChargeByType {
  charge_type: string;
  list: Array<ServiceCharge>;
}


// WEBPACK FOOTER //
// ./src/app/response/admin/admservicechargeresult.ts